import { type WidgetActionHandler } from '../types/WidgetVariant';

import { ActionMethod, type Actions } from '../types/WidgetVariantFic';

export const createWidgetVariantFicClient = (namespace: string): Actions =>
  Object.values(ActionMethod).reduce((acc, method) => {
    acc[method as keyof Actions] = (...options: unknown[]) =>
      ((window as unknown as Record<string, unknown>)[namespace] as WidgetActionHandler)(method, ...options);
    return acc;
  }, {} as Actions);
